import React from 'react';
import { useTranslation } from 'next-i18next';
import { Button } from '@zep/ui';
import { ErrorWidget } from '../ErrorWidget';
export const Error500Widget = () => {
  const {
    t,
    ready
  } = useTranslation(['common']);
  const imageUrl = '/images/error_500.png';
  const title = t('common:unknownError.title');
  const description = t('common:unknownError.content');
  if (!ready) return null;
  return <ErrorWidget.Root data-sentry-element="unknown" data-sentry-component="Error500Widget" data-sentry-source-file="Error500Widget.tsx">
      <ErrorWidget.Header data-sentry-element="unknown" data-sentry-source-file="Error500Widget.tsx">
        <ErrorWidget.Image src={imageUrl} data-sentry-element="unknown" data-sentry-source-file="Error500Widget.tsx" />
      </ErrorWidget.Header>
      <ErrorWidget.Content data-sentry-element="unknown" data-sentry-source-file="Error500Widget.tsx">
        <ErrorWidget.Title data-sentry-element="unknown" data-sentry-source-file="Error500Widget.tsx">{title}</ErrorWidget.Title>
        <ErrorWidget.Description data-sentry-element="unknown" data-sentry-source-file="Error500Widget.tsx">{description}</ErrorWidget.Description>
      </ErrorWidget.Content>
      <ErrorWidget.Footer data-sentry-element="unknown" data-sentry-source-file="Error500Widget.tsx">
        <Button size="lg" as="a" href={t('common:unknownError.buttonHelp.link') ?? ''} variant="secondary" data-sentry-element="Button" data-sentry-source-file="Error500Widget.tsx">
          {t('common:unknownError.buttonHelp.title')}
        </Button>
        <Button size="lg" as="a" href="/" data-sentry-element="Button" data-sentry-source-file="Error500Widget.tsx">
          {t('common:unknownError.buttonHome')}
        </Button>
      </ErrorWidget.Footer>
    </ErrorWidget.Root>;
};